const config = {
  ENVIRONMENT_NAME: 'prod',
  forwoodId: {
    URL: 'https://id.uat.forwood.one',
    USER_TOKEN_URL: 'https://dt0mdk68t6.execute-api.us-west-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://e3hmiddy92.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'admin-container-1.11.5',
    HOSTNAME: 'https://admin.uat.forwood.one',
    COMPANY_MICROFRONTEND_URL: 'https://company.uat.forwood.one',
    PHYSICAL_LOCATION_MICROFRONTEND_URL: 'https://locations.uat.forwood.one'
  },
  configurationService: {
    URL: 'https://config.uat.forwood.one',
    WEBSOCKET: 'wss://30xjv1z799.execute-api.us-west-2.amazonaws.com/prod'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
